"use client";

import { OverlayProvider } from "react-aria";

export default OverlayProvider;
